import { render, staticRenderFns } from "./GPriceForm.vue?vue&type=template&id=665b5a96&"
import script from "./GPriceForm.vue?vue&type=script&lang=ts&"
export * from "./GPriceForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports